import Vue from 'vue';
import equipmentTransformer from '../../transformers/equipment';
import store from '../../store';

const success = ({ data }) => equipmentTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const equipments = store.state.equipment.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (equipments.length > 0) {
      return resolve(equipments[0]);
    }

    return Vue.$http.get(`/production/equipments/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/equipment/show.js